import React from "react";
import PropTypes from "prop-types";
import { ArrowLeft, ArrowRight } from "lucide-react";

import Button from "./Button";
import FormStepBar from "./FormStepBar";

const CreatePackWorkflowFrame = ({
  children,
  currentStep,
  loading = false,
  onNext,
  onPrevious,
  onStepSelect,
  saveStatus,
  steps,
}) => {
  const currentIndex = Math.max(steps.findIndex((step) => step.id === currentStep), 0);
  const current = steps[currentIndex];
  const isLastStep = currentIndex === steps.length - 1;

  return (
    <section aria-labelledby="create-pack-step-title" className="wsm-create-pack-workflow">
      <FormStepBar currentStep={currentStep} onStepSelect={onStepSelect} steps={steps} />
      <div className="wsm-create-pack-workflow__main">
        <header className="wsm-pack-form__header">
          <p>Step {currentIndex + 1} of {steps.length}</p>
          <h2 id="create-pack-step-title">{current.title || current.label}</h2>
          {current.longDescription && <span>{current.longDescription}</span>}
        </header>

        <div className="wsm-create-pack-workflow__content">{children}</div>

        <footer className="wsm-pack-form__footer">
          <Button disabled={!onPrevious || loading} icon={ArrowLeft} onClick={onPrevious} type="button" variant="outline">Previous</Button>
          {saveStatus && <p aria-live="polite">{saveStatus}</p>}
          <Button disabled={loading} icon={ArrowRight} iconPosition="end" loading={loading} loadingLabel="Saving..." onClick={onNext} type="button">
            {isLastStep ? "Create pack" : "Continue to " + steps[currentIndex + 1].label.toLowerCase()}
          </Button>
        </footer>
      </div>
    </section>
  );
};

CreatePackWorkflowFrame.propTypes = {
  children: PropTypes.node.isRequired,
  currentStep: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func,
  onStepSelect: PropTypes.func,
  saveStatus: PropTypes.string,
  steps: FormStepBar.propTypes.steps,
};

export default CreatePackWorkflowFrame;